export class ButtonsModel {

    public label: string;
    public color: string;
    public fontColor: string;
    public icon: string;
    public callback: (item: unknown, type?: number) => void;

    constructor(label: string, color: string, icon: string, callback: (item: unknown) => void, fontColor?: string) {
        this.label = label;
        this.color = color;
        this.icon = icon;
        this.callback = callback;
        this.fontColor = fontColor;
    }
}
